import 'css-chunksrc/client/scenes/workloads/wbs/event/dateForm/dateTimeInput/styles.scss';export default {
  "dateTimeInput": "_dateTimeInput_10lno_1",
  "input": "_input_10lno_6",
  "placeholder": "_placeholder_10lno_22",
  "value": "_value_10lno_27",
  "calendarInput": "_calendarInput_10lno_32",
  "calendar": "_calendar_10lno_32",
  "timeList": "_timeList_10lno_48",
  "timeListWrapper": "_timeListWrapper_10lno_57",
  "time": "_time_10lno_48",
  "timeName": "_timeName_10lno_69",
  "invalid": "_invalid_10lno_75",
  "disabled": "_disabled_10lno_83"
};